/**
 * Generate a query string.
 * @param {Object.<string, *>} obj
 * @param {string} prefix
 */
export function toQueryString(obj, prefix = '') {
  const str = [];

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      const key = prefix ? `${prefix}[${property}]` : property;
      const value = obj[property];

      if (value === undefined || value === null) {
        continue;
      }

      str.push(
        typeof value === 'object' ?
          toQueryString(value, key) :
          `${window.encodeURIComponent(key)}=${window.encodeURIComponent(value)}`,
      );
    }
  }

  return str.join('&');
}
